module.exports = __webpack_public_path__ + "img/about1-1.f9575b33.png";